import React from 'react';

const VipBadge = ({ size = 'medium' }) => {
  const sizes = {
    small: { text: '10px', padding: '3px 12px', width: '42px' },
    medium: { text: '12px', padding: '4px 16px', width: '52px' },
    large: { text: '14px', padding: '5px 20px', width: '64px' }
  };

  const s = sizes[size] || sizes.medium;

  return (
    <div style={{ marginTop: '6px' }}>
      <span
        style={{
          display: 'inline-block',
          background: 'linear-gradient(180deg, #ff4444 0%, #cc0000 50%, #990000 100%)',
          borderRadius: '6px',
          padding: s.padding,
          minWidth: s.width,
          fontSize: s.text,
          fontWeight: '900',
          color: '#ffffff',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
          letterSpacing: '2px',
          boxShadow: '0 3px 10px rgba(204, 0, 0, 0.4), inset 0 2px 0 rgba(255, 255, 255, 0.3), inset 0 -2px 4px rgba(0,0,0,0.2)',
          border: '2px solid #990000',
          fontFamily: 'Arial Black, Gadget, sans-serif',
          animation: 'vipShine 2s ease-in-out infinite',
          textAlign: 'center',
          textTransform: 'uppercase'
        }}
      >
        VIP
      </span>
      <style>{`
        @keyframes vipShine {
          0%, 100% { filter: brightness(1); }
          50% { filter: brightness(1.15); transform: scale(1.02); }
        }
      `}</style>
    </div>
  );
};

export default VipBadge;
